export const RESET = 'BACKUP_TYPE_LIST_RESET'
export const SET_ITEMS = 'BACKUP_TYPE_LIST_SET_ITEMS'
export const SET_ERROR = 'BACKUP_TYPE_LIST_SET_ERROR'
export const SET_VIEW = 'BACKUP_TYPE_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'BACKUP_TYPE_LIST_TOGGLE_LOADING'
